import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import Dotdotdot from 'react-dotdotdot';
import styled from 'styled-components';
import { Avatar } from "../../../avatar/src";
import { Box } from "../../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../../font-awesome-icon/src";
export const TrendingPresentation = ({ comments, icon, isLast, likes, onClick, title, type, }) => {
    const [cardHovered, setCardHovered] = useState(false);
    const clickableProps = useMemo(() => onClick && {
        onClick,
        onMouseEnter: () => setCardHovered(true),
        onMouseLeave: () => setCardHovered(false),
    }, [onClick]);
    return (_jsxs(TrendingPresentationCard, Object.assign({}, clickableProps, { "$isLast": isLast, children: [_jsxs(Box, { alignItems: "center", children: [_jsx(Box, { flex: "none", height: "40px", width: "40px", children: _jsx(Avatar, { alt: "", src: icon }) }), _jsxs(Box, { flexDirection: "column", ml: 3, children: [type && _jsx(Box, { font: "body-semibold-asphalt", children: type }), title && (_jsx(Title, { "$cardHovered": cardHovered, children: _jsx(Dotdotdot, { clamp: 1, children: title }) }))] })] }), _jsx(Icons, { comments: comments, likes: likes })] })));
};
const Icons = ({ comments, likes, }) => (_jsxs(Box, { children: [_jsxs(Box, { children: [_jsx(FontAwesomeIcon, { color: "primary", height: "20px", iconName: "heart", iconType: CATEGORIES.SOLID }), _jsx(Box, { ml: 3, children: likes })] }), _jsxs(Box, { ml: 6, children: [_jsx(FontAwesomeIcon, { height: "20px", iconName: "message" }), _jsx(Box, { ml: 3, children: comments })] })] }));
const TrendingPresentationCard = styled(Box).attrs(({ $isLast }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: $isLast ? 2 : 5,
    width: '100%',
})) `
  &:hover,
  &:focus {
    cursor: pointer;
  }
`;
const Title = styled(Box) `
  color: ${({ $cardHovered, theme }) => $cardHovered ? theme.colors.link : 'inherit'};
  text-decoration: ${({ $cardHovered }) => $cardHovered ? 'underline' : 'none'};
`;
//# sourceMappingURL=TrendingPresentation.js.map